<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="col-md-12 px-0">
        <div class="row mx-md-auto px-0">
          <div class="col-md-6 px-0 px-md-3 mx-md-auto px-0">
            <div class="rowinfo">
              <v-text-field
                v-model="data.companyName"
                append-icon="mdi-store"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="40"
                class="contentinfo"
                dense
                :hint="$t('hint_shopping')"
                :label="$t('name_shopping')"
                maxLength="40"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-companyName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('name_shopping')"
              />
            </div>
          </div>
          <div class="col-md-6 px-0 px-md-3 mx-md-auto px-0">
            <div class="rowinfo">
              <v-text-field
                v-model="data.titleCompany"
                append-icon="mdi-store"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="40"
                dense
                class="contentinfo"
                :hint="$t('hint_discount')"
                :label="$t('title_discount')"
                maxLength="40"
                outlined
              />

              <help-info
                :element-name="`${serviceName}-${componentName}-data-titleCompany`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('title_discount')"
              />
            </div>
          </div>
          <div class="col-md-6 px-0 px-md-3 mx-auto">
            <div class="rowinfo">
              <v-text-field
                v-model="data.titleDiscount"
                append-icon="mdi-percent"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="30"
                class="contentinfo"
                dense
                :hint="$t('hint_mount_discount')"
                :label="$t('label_discount')"
                maxLength="30"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-titleCompany`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('label_discount')"
              />
            </div>
          </div>
          <div class="col-md-6 px-0 px-md-3 mx-auto">
            <div class="rowinfo">
              <v-text-field
                v-model="data.giveCopan"
                append-icon="mdi-percent"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="30"
                class="contentinfo"
                dense
                :hint="$t('give_discount')"
                :label="$t('give_copon')"
                maxLength="30"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-giveCopan`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('enter_copon')"
              />
            </div>
          </div>
          <div class="col-md-6 px-0 px-md-3 mx-auto">
            <div class="rowinfo">
              <v-text-field
                v-model="data.companyNumber"
                append-icon="mdi-phone"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="20"
                class="contentinfo"
                dense
                :hint="$t('hint_phone')"
                :label="$t('label_phone')"
                maxLength="20"
                outlined
              >
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-companyNumber`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('label_phone')"
              />
            </div>
          </div>
        </div>
        <div class="row mx-md-auto px-0">
          <div class="col-md-12 px-0 px-md-3 mx-auto">
            <div class="rowinfo">
              <v-textarea
                v-model="data.descriptionDiscount"
                append-icon="mdi-note-text"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="256"
                dense
                :hint="$t('hint_condition_discount')"
                :label="$t('label_discription_discount')"
                maxLength="256"
                outlined
                rows="3"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-descriptionDiscount`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('label_discription_discount')"
              />
            </div>
          </div>
        </div>

        <div class="row mx-md-auto px-0">
          <!--            <div class="col-md-6 px-0 px-md-3 mx-auto">-->
          <!--                <v-text-field outlined-->
          <!--                              dense-->
          <!--                              v-model="data.city"-->
          <!--                              hint="لطفا شهر خود را وارد کنید."-->
          <!--                              maxLength="50"-->
          <!--                              counter="50"-->
          <!--                              label="شهر"-->
          <!--                              append-icon="location_on"/>-->
          <!--            </div>-->
        </div>

        <v-card-title class="pb-0"> {{ $t("add_info_discount") }}</v-card-title>
        <v-divider />

        <v-divider />

        <div class="col-md-12 mx-md-auto px-md-3 px-0">
          <div class="rowinfo">
            <v-textarea
              v-model="data.location"
              append-icon="mdi-map-marker"
              class="mx-0"
              clear-icon="mdi-close-circle-outline"
              clearable
              counter="160"
              dense
              :hint="$t('enter_address_discount')"
              :label="$t('address_discount')"
              maxLength="160"
              outlined
              rows="3"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-location`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('address_discount')"
            />
          </div>
        </div>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "./helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "./helpAcordion/HelpInfoWrapper.vue";
import axios from "axios";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import SuggestText from "../../../components/SuggestBox/suggestInput";
import IconPicker from "../../../components/IconPicker";

export default {
  name: "textCards",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    IconPicker,
    SuggestText,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
  },

  props: {
    data: {
      default: {},
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "text-card-discoiunt",
      searchTitle: "",

      geom: "",
      suggests: {},
      mapLoading: false,
      apiKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
    };
  },

  computed: {
    getCenter() {
      return this.data.center ?? [51.420296, 35.732379];
    },
    urlRules() {
      return [(value) => this.isURL(value) || this.$t("domain_format")];
    },
  },

  methods: {
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    search() {
      this.mapLoading = true;
      axios({
        method: "GET",
        baseURL: "https://map.ir/search/v2",
        params: { text: this.searchTitle },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.suggests = response.data.value;
          this.data.center = response.data.value.coordinates;
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    getlatLng(e) {
      this.mapLoading = true;
      this.data.coordinates = Object.values(e.actualEvent.lngLat);
      if (
        this.data.coordinates[0] !== NaN &&
        this.data.coordinates[1] !== NaN
      ) {
        axios({
          method: "GET",
          baseURL: "https://map.ir/reverse",
          params: {
            lat: this.data.coordinates[1],
            lon: this.data.coordinates[0],
          },
          timeout: 15000,
          headers: {
            "x-api-key":
              "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            this.mapLoading = false;
            this.data.address = response.data.address;
          })
          .finally(() => {
            this.mapLoading = false;
          });
      }
    },
    getBySearch() {
      this.mapLoading = true;
      this.data.coordinates = this.geom.coordinates;
      if (
        this.data.coordinates[0] !== NaN &&
        this.data.coordinates[1] !== NaN
      ) {
        axios({
          method: "GET",
          baseURL: "https://map.ir/reverse",
          params: {
            lat: this.data.coordinates[1],
            lon: this.data.coordinates[0],
          },
          timeout: 15000,
          headers: {
            "x-api-key":
              "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            this.mapLoading = false;
            this.data.address = response.data.address;
          })
          .finally(() => {
            this.mapLoading = false;
          });
      }
    },

    addExtra() {
      this.data.extraFields.push({
        icon: "",
        name: "",
        value: "",
      });
    },
    removeExtra(index) {
      if (this.data.extraFields.length <= 1) {
        this.data.extraFields[0] = {
          icon: "",
          name: "",
          value: "",
        };
      } else {
        this.data.extraFields.splice(index, 1);
      }
    },
    removeLocation() {
      this.data.coordinates = null;
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    geom: function (val) {
      this.getBySearch();
    },
  },
};
</script>

<style scoped></style>
